import React, {useEffect} from 'react';
import "../styles/Terms&Conditions.css";

const TermsAndConditions = () => {
  useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, []);
  return (
    <div>
       <div className="terms-conditions">
            <h1>Terms & Conditions</h1>
            <h2>Booking & Reservation</h2>
            <ul>
                <li>All reservations must be guaranteed with a valid payment method at the time of booking.</li>
                <li>Guests must provide valid identification (Aadhar card, Passport, or Driver’s License) upon check-in.</li>
                <li>Room rates are subject to change without prior notice.</li>
                <li>The maximum number of guests per room must not exceed the specified limit.</li>
                <li>Early check-in and late check-out are subject to availability and may incur additional charges.</li>
                <li>Late check-out beyond the allowed time will result in an extra day's charge.</li>
            </ul>
            <h2>Cancellation & Refund Policy</h2>
            <ul>
                <li>The cancellation policy is as follows, as we have a four-month opening season each year.</li>
                <li>Cancellation more than 1 month prior to the arrival date : 80% refund</li>
                <li>Cancellation 30 days prior to the arrival date : 65% refund.</li>
                <li>Cancellation 25 days prior to the arrival date : 50% refund.</li>
                <li>Cancellation 20 days prior to the arrival date : 35% refund.</li>
                <li>Cancellation 10 days prior to the arrival date : 20% refund.</li>
                <li>Cancellation within 9 days prior to the arrival date : No refund.</li>
                <li>Refunds will be processed within 5 to 7 working days.</li>
            </ul>
        
            <h2>Guest Responsibilities</h2>
            <ul>
                <li>Guests are responsible for their belongings. The hotel is not liable for lost, stolen, or damaged valuables.</li>
                <li>Any damage to the hotel property caused by guests will be charged accordingly.</li>
                <li>Smoking is strictly prohibited in non-smoking rooms and designated areas.</li>
                <li>Illegal activities are not permitted within the premises.</li>
            </ul>
            <h2>Housekeeping & Maintenance</h2>
            <ul>
                <li>Housekeeping services will be provided (Daily/On Request).</li>
                <li>Any maintenance issues must be reported immediately to the front desk.</li>
                <li>Room service is available between 7am to 10pm.</li>
                <li>Guests are responsible for informing the staff of any food allergies.</li>
                <li>The hotel is not responsible for delays or failures in services due to events beyond our control (natural disasters, power outages, strikes, etc.).</li>
            </ul>
            <h2>Payment Gateway Charges</h2>
            <ul>
                <li>Our hotel uses a secure third-party payment gateway for processing online bookings and refunds.</li>
                <li>A 2% transaction fee plus applicable GST is deducted by the payment gateway on all payments and refunds.</li>
                <li>This charge is non-refundable, even if a refund is processed.</li>
                <li>The refunded amount will be credited after deducting the payment gateway charges.</li>
            </ul>
            <p>By making a reservation and staying at Hotel Shyam Palace, you agree to abide by these terms and conditions.</p>
            <p>To avoid any inconvenience, please complete the deposit at your earliest convenience.</p>
            <h3>Regards</h3> <strong>HOTEL SHYAM PALACE GHANGRIA</strong>
        </div>
    </div>
  )
}

export default TermsAndConditions
